import { render, staticRenderFns } from "./HowToOrder.vue?vue&type=template&id=33c45e10&scoped=true&"
import script from "./HowToOrder.vue?vue&type=script&setup=true&lang=js&"
export * from "./HowToOrder.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./HowToOrder.vue?vue&type=style&index=0&id=33c45e10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c45e10",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QDialog});
